import * as helper from './../helper';
// require('expose-loader?exposes=ModalboxPayment!./../vxpay-iframe');

export default class paytourHelper {
	constructor() {
		this.isInitialized = false;
		this.modalBox = null;
		this.exitIntentAdtv = '';
		this.ab1 = 0; // AB Test: 0 = normal signup and payment, 1 = only signup

		helper.addEventListener(window, 'ExitIntentClosed', function (evt) {
			if (!paytourHelper.isInitialized) {
				let split = evt.originalEvent.detail.adtv.split(',');
				paytourHelper.exitIntentAdtv = split.pop();
			} else {
				paytourHelper.modalBox.sendOptions({adtv: evt.originalEvent.detail.adtv});
			}
		});
	}

	/**
	 * Initialize Paytour with options
	 *
	 * @param {Object} options
	 * @param {Object} events
	 */
	initPaytour(options = {}, events = {}) {
		if (!options.hasOwnProperty('agbUrl')) {
			options.agbUrl = 'https://www.visit-x.net/de/agb/';
		}
		if (!options.hasOwnProperty('privacyUrl')) {
			options.privacyUrl = 'https://www.visit-x.net/de/datenschutz/';
		}
		if (!options.hasOwnProperty('pfm')) {
			options.pfm = 1502;
		}

		if (this.isInitialized !== true) {
			let urls = this._buildUrls(options);
			let config = this._buildConfig(options);

			let query = urls.baseUrl.substr(urls.baseUrl.indexOf('?'));

			// Extend AGB and Privacy with webmaster data.
			if (options.agbUrl.indexOf('?') === -1) {
				options.agbUrl += query;
			}
			if (options.privacyUrl.indexOf('?') === -1) {
				options.privacyUrl += query;
			}

			if (this.ab1 === 1 && typeof options.option === 'string') {
				if (urls['successUrl'].indexOf('?') === -1) {
					urls['successUrl'] += '?option=' + options.option;
				} else {
					urls['successUrl'] += '&option=' + options.option;
				}
			}

			this.modalBox = new ModalboxPayment(
				urls,
				window,
				options,
				config,
				events
			);
			this._addCloseListener();
			this.modalBox.initPaytour();

			window.paytour = this.modalBox;

			this.isInitialized = true;
		} else {
			window.paytour.sendOptions(options);
		}
	}

	/**
	 * Open Paytour (Signup and Payment) with options
	 *
	 * Options will only be used, if initPaytour(options) has not been called before!
	 * openPaytour implies initPaytour, so initPaytour normally does not have to be called by itself.
	 *
	 * @param {object} options
	 * @param {object} events
	 */
	openPaytour(options = {}, events = {}) {
		this.initPaytour(options, events);

		if (this.ab1 === 1) {
			this.openSignup(options, events);
		} else {
			helper.triggerEvent(window.top, 'openedPaytour');
			this.modalBox.openPaytour(options);
		}
	}

	/**
	 * Opens Signup (without Payment) with options
	 *
	 * Options will only be used, if initPaytour(options) has not been called before!
	 * openSignup implies initPaytour, so initPaytour normally does not have to be called by itself.
	 *
	 * @param {object} options
	 * @param {object} events
	 */
	openSignup(options = {}, events = {}) {
		this.initPaytour(options, events);
		helper.triggerEvent(window.top, 'openedPaytour');
		this.modalBox.openSignup(options);
	}

	/**
	 * Opens new Trial Abo with options
	 *
	 * openAboPaytour implies initPaytour, so initPaytour normally does not have to be called by itself.
	 *
	 * @param {object} options
	 * @param {object} events
	 */
	openAboPaytour(options = {}, events= {}) {
		this.initPaytour(options, events);
		helper.triggerEvent(window.top, 'openedPaytour');
		this.modalBox.openTrialAboPaytour(options);
	}

	/**
	 * Opens Login with options
	 *
	 * openLogin implies initPaytour, so initPaytour normally does not have to be called by itself.
	 *
	 * @param {object} options
	 * @param {object} events
	 */
	openLogin(options = {}, events = {}) {
		this.initPaytour(options, events);
		helper.triggerEvent(window.top, 'openedPaytour');
		this.modalBox.openLogin(options);
	}

	/**
	 * Opens VX TV Abo signup
	 *
	 * @param options
	 * @param events
	 */
	openVXTVAbo(options = {}, events= {}) {
		this.initPaytour(options, events);
		helper.triggerEvent(window.top, 'openedPaytour');
		this.modalBox.openVXTVAbo(options);
	}

	/**
	 * Build basic url object from data
	 *
	 * @returns {{baseUrl: string, successUrl: string}}
	 * @private
	 */
	_buildUrls(options) {
		let infoElement = document.getElementById('vxpt_info');
		let paytourUrl = helper.getData(infoElement, 'paytoururl');
		let successUrl = typeof options.successUrl !== 'undefined' ? options.successUrl : helper.getData(infoElement, 'successurl');

		if (this.exitIntentAdtv !== '') {
			paytourUrl = paytourUrl.replace(/(adtv=[^&]+)/, '$1,' + this.exitIntentAdtv);
		}

		return {
			baseUrl: paytourUrl,
			successUrl: successUrl
		};
	}

	/**
	 * Build basic config object from options
	 *
	 * Currently only checks if the hideClose function should be used and if so, extends the config object with
	 * the necessary value.
	 *
	 * @param options
	 * @returns {object}
	 * @private
	 */
	_buildConfig(options = {}) {
		let config = { lazy: true };
		let infoElement = document.getElementById('vxpt_info');

		if (helper.getData(infoElement, 'oauth')) {
			config.showOAuth = 1;
		}

		this.ab1 = parseInt(helper.getData(infoElement, 'flow'));

		if (options.hasOwnProperty('hideClose') && options.hideClose === true) {
			config.hideClose = true;
		}

		if (options.hasOwnProperty('showThank')) {
			config.showThank = options.showThank;
		}

		if (options.hasOwnProperty('login')) {
			config.login = options.login;
		}

		if (options.hasOwnProperty('texts')) {
			config.texts = options.texts;
		}

		if (options.hasOwnProperty('conversion')) {
			config.conversion = options.conversion;
		}

		return config;
	}

	/**
	 * Add close listener for Versions that do stuff on close
	 *
	 * @private
	 */
	_addCloseListener() {
		this.modalBox.onClose = function (result) {
			if (typeof result !== 'undefined' &&
				result.hasOwnProperty('isLoggedIn') &&
				result.isLoggedIn === true) {
				helper.triggerEvent(window.top, 'paymentAbandoned');
			}
			helper.triggerEvent(window.top, 'paytourClose');
		};
	}
}
